/**
 * iter76c — Emails parent tab. Groups the two email-ops pages so the
 * admin sidebar has one nav item for anything email-related instead
 * of two.
 *
 * Sub-tabs:
 *   • Calendar → scheduled/queued email jobs
 *   • Health   → Resend delivery status, bounce/complaint monitoring
 */
import { useState } from "react";
import { Calendar, Activity } from "lucide-react";
import EmailCalendarTab from "./EmailCalendarTab";
import EmailHealthTab from "./EmailHealthTab";

const SUBS = [
  { k: "calendar", l: "Calendar", Icon: Calendar },
  { k: "health", l: "Health", Icon: Activity },
];

export default function EmailsParentTab({ pw }) {
  const [sub, setSub] = useState("calendar");
  return (
    <div data-testid="emails-parent-tab">
      <div className="flex gap-1.5 flex-wrap mb-5 border-b border-[#222] pb-2">
        {SUBS.map(({ k, l, Icon }) => (
          <button
            key={k}
            onClick={() => setSub(k)}
            data-testid={`emails-sub-${k}`}
            className={`px-3 py-1.5 border font-mono text-[10px] tracking-widest uppercase inline-flex items-center gap-1.5 ${
              sub === k
                ? "bg-[var(--tc-red)] border-[var(--tc-red)] text-white"
                : "border-[#222] text-zinc-400 hover:text-white"
            }`}
          >
            <Icon size={11} /> {l}
          </button>
        ))}
      </div>
      {sub === "calendar" && <EmailCalendarTab pw={pw} />}
      {sub === "health" && <EmailHealthTab pw={pw} />}
    </div>
  );
}
